<script setup lang="ts">
import {Swiper, SwiperSlide} from 'swiper/vue';
import {useRoute} from 'vue-router';
import EmailForm from '@/components/register/EmailForm.vue';
import {computed, ref} from 'vue';
import {decodeFromBase64} from '@/utils/buffer';

// props, context, emits, libs
const route = useRoute();

// NOTE: 보안상으로 덜 명시적인 키 값 사용
const {cn: encodedCompanyName, ci: encodedCompanyId} = route.query as Record<
    string,
    string | undefined
>;

// ref, reactive
// computed
const decodedCompanyId = computed(() => {
    return encodedCompanyId ? Number(decodeFromBase64(encodedCompanyId)) : null;
});

// NOTE: 복지몰회원(상용 companyId: 487)사인 경우, 이메일 인증을 생략함
const isSkipEmailVerification = computed(() => {
    let skipCompanyIds: (number | null)[] | null;
    switch (import.meta.env.VITE_APP_ENVIRONMENT) {
        case 'dev':
            // dev 서버 테스트용 companyId
            skipCompanyIds = [1086];
            break;
        case 'stage':
            // stage 서버 테스트용 companyId
            skipCompanyIds = [2883, 786, 1322];
            break;
        case 'release':
            // 상용 '복지몰회원'사 companyId
            skipCompanyIds = [487, 786, 1322, 4437, 2687, 1312, 719, 685, 477, 4752];
            break;
        default:
            skipCompanyIds = null;
            break;
    }

    // return decodedCompanyId.value === skipCompanyId;
    return skipCompanyIds?.includes(decodedCompanyId.value);
});

const stepArray = ref(
    Array.from(
        new Array(isSkipEmailVerification.value ? 4 : 5),
        (x, i) => i + 1,
    ),
);

// methods
// effect (created, mounted, watch, VueUse)
</script>

<template>
    <div class="register">
        <div class="register__bullets">
            <ul>
                <li
                    v-for="(step, index) in stepArray"
                    :key="step"
                    :class="{register__bullets__current: index === 0}"
                >
                    {{ step }}
                </li>
            </ul>
        </div>
        <swiper class="register__swiper" :allow-touch-move="false">
            <swiper-slide class="register__swiper__slide">
                <EmailForm
                    :isSkipEmailVerification="isSkipEmailVerification as boolean"
                    :companyIds="{
                        encodedCompanyId,
                        decodedCompanyId,
                    }"
                    :encodedCompanyName="encodedCompanyName"
                />
            </swiper-slide>
        </swiper>
    </div>
</template>

<style lang="scss" scoped>
:global(#app) {
    min-width: 280px !important;
}
.register {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 56px;
    background-color: $white;
    height: calc(100vh - 56px);

    &__bullets {
        margin: 16px 0 40px 0;

        ul {
            display: flex;
            align-items: center;
            user-select: none;
        }

        ul > li {
            display: inline-block;
            margin: 0 8px;
            font-size: 11px;
            text-align: center;
            line-height: 1.3;
            width: 8px;
            height: 8px;
            background-color: $black_08;
            border-radius: 50%;
            color: transparent;
        }

        &__current {
            width: 14px !important;
            height: 14px !important;
            color: $white !important;
            background-color: $black_40 !important;
        }

        &__past {
            background-color: $black_40 !important;
        }
    }

    &__swiper {
        width: 100%;
        height: 100%;

        &__slide {
            display: flex;
            justify-content: center;
        }
    }
}
</style>
